import React, { useState, useEffect } from 'react';
import { FormGenerator } from '@hwm/ui-lib';
import { ChannelUnitsModel, DigitalIntervalOptionsType, GraphExportType, PreferencesFormModel } from '@shared/models';
import { useFormikContext } from 'formik';
import { graphPreferencesFieldsConfiguration } from './GraphPreferences.utils';
import { isEmpty } from 'lodash';

interface GraphPreferencesProps {
  unitPreferencesOptions: Record<string, ChannelUnitsModel[]>;
  graphExports: GraphExportType[];
  digitalIntervals: DigitalIntervalOptionsType[];
  cumulativeModes: DigitalIntervalOptionsType[];
}

export const GraphPreferences: React.FC<GraphPreferencesProps> = ({
  unitPreferencesOptions,
  graphExports,
  digitalIntervals,
  cumulativeModes,
}) => {
  const { values, errors, touched, handleBlur, handleChange, setFieldValue, validateField } =
    useFormikContext<PreferencesFormModel>();

  const [type, setType] = useState('');

  useEffect(() => {
    if (!type && values.graphUnitPreferences && !isEmpty(values.graphUnitPreferences)) {
      setType(Object.keys(values.graphUnitPreferences)?.[0]);
    }
  }, [type, values.graphUnitPreferences]);

  return (
    <div>
      <FormGenerator
        fieldsConfiguration={graphPreferencesFieldsConfiguration(
          type,
          setType,
          unitPreferencesOptions,
          graphExports,
          digitalIntervals,
          cumulativeModes
        )}
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        validateField={validateField}
        formDisabled={false}
        newEditableLook
      />
    </div>
  );
};
